export const getMarchesData = () => ({
  name: "Marches",
  country: "Italie",
  description: "Les Marches sont une région viticole du centre-est de l'Italie, s'étendant des Apennins à l'Adriatique. Cette région produit principalement des vins rouges structurés et des vins blancs aromatiques, avec une forte identité locale et des cépages autochtones.",
  type: "region",
  mapAreas: [
    { region: "Marches", x: 50, y: 48, color: "#4B164C", size: 3 }
  ],
  statistics: {
    totalArea: "25,000 ha",
    production: "1.8 million hectolitres",
    appellations: "15 DOC et 5 DOCG",
    provinces: "5 provinces",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat méditerranéen avec influence continentale, étés chauds et hivers froids",
    soil: "Sols très variés : calcaire, argile, flysch, sable",
    viticulture: "Viticulture traditionnelle, vignobles en coteaux et en plaine"
  },
  wineStyles: {
    red: "Vins rouges structurés et tanniques, avec une forte identité cépage",
    white: "Vins blancs secs et aromatiques, frais et complexes",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sweet: "Vins doux traditionnels, vendanges tardives"
  },
  history: "La viticulture dans les Marches remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XIXe siècle a vu l'émergence des appellations. Aujourd'hui, la région est reconnue pour ses vins de qualité et ses cépages autochtones.",
  foodPairing: "Cuisine marchigiane, viandes rouges, poissons, charcuteries, cuisine côtière",
  subregions: {
    "conero": {
      name: "Conero",
      description: "Région prestigieuse produisant des vins rouges structurés et tanniques, avec une forte identité cépage.",
      characteristics: {
        climate: "Climat méditerranéen avec influence maritime",
        soil: "Sols calcaires et argileux",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        red: ["Montepulciano", "Sangiovese", "Cabernet Sauvignon"]
      },
      wineStyles: {
        "conero": "Vins rouges structurés et tanniques",
        "conero-riserva": "Vins rouges puissants et concentrés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine marchigiane"
    },
    "verdicchio": {
      name: "Verdicchio",
      description: "Région produisant des vins blancs secs et aromatiques, avec une forte identité cépage.",
      characteristics: {
        climate: "Climat méditerranéen avec influence continentale",
        soil: "Sols argileux et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        white: ["Verdicchio", "Trebbiano", "Malvasia"]
      },
      wineStyles: {
        "verdicchio-dei-castelli-di-jesi": "Vins blancs secs et aromatiques",
        "verdicchio-di-matelica": "Vins blancs secs et structurés"
      },
      foodPairing: "Poissons, fruits de mer, volailles, fromages, cuisine côtière"
    },
    "piceno": {
      name: "Piceno",
      description: "Région produisant des vins rouges et blancs de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat méditerranéen avec influence continentale",
        soil: "Sols argileux et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        red: ["Montepulciano", "Sangiovese", "Pecorino"],
        white: ["Trebbiano", "Passerina", "Pecorino"]
      },
      wineStyles: {
        "piceno-rosso": "Vins rouges structurés et équilibrés",
        "piceno-bianco": "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes rouges, volailles, fromages, cuisine traditionnelle"
    },
    "esino": {
      name: "Esino",
      description: "Région produisant des vins rouges et blancs de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat méditerranéen avec influence continentale",
        soil: "Sols argileux et calcaires",
        viticulture: "Viticulture traditionnelle, vignobles en coteaux"
      },
      grapeVarieties: {
        red: ["Montepulciano", "Sangiovese"],
        white: ["Verdicchio", "Trebbiano"]
      },
      wineStyles: {
        "esino-rosso": "Vins rouges fruités et équilibrés",
        "esino-bianco": "Vins blancs secs et frais"
      },
      foodPairing: "Viandes rouges, volailles, fromages, cuisine traditionnelle"
    }
  }
}); 